import { useEffect } from "react";
import { OkthxLogo } from "@/components/icons/Logo.tsx";
import { SiteHeaderWrapper, ViewWrapper } from "@/components/layout/ViewWrapper.tsx";
import { GetIphoneApp } from "@/components/notifications/GetIphoneApp.tsx";
import { Button } from "@/components/ui/button.tsx";
import { isIOS } from "@/lib/utils.ts";
import { APP_STORE_URL } from "@/shared/appStore.ts";

/**
 * Where links to "get the Okthx app" land, texts from Okthx included. Public:
 * it renders before sign-in and outside Statsig. An iPhone goes straight on to
 * the App Store; anything else sees the way to get it there.
 */
export const Download = () => {
  // Not inside the iOS app's WebView, which has the app already.
  const redirects = isIOS() && window.isWebView !== true;
  useEffect(() => {
    if (redirects) window.location.replace(APP_STORE_URL);
  }, [redirects]);

  if (redirects) return null;
  return (
    <ViewWrapper headerContent={<SiteHeaderWrapper />}>
      <main className="flex min-h-[80vh] flex-col items-center bg-background">
        <section className="mx-auto flex w-full max-w-md flex-col items-center gap-6 px-4 py-16 text-center">
          <OkthxLogo className="size-16 drop-shadow" />
          <div className="flex flex-col gap-2">
            <h1 className="text-3xl font-bold">Get Okthx for iPhone</h1>
            <p className="text-lg text-muted-foreground">
              Reminders, approvals and updates, wherever you are.
            </p>
          </div>
          <GetIphoneApp qrSize={176} />
          <Button asChild variant="outline" data-statsig-name="download-app-store">
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
              Open the App Store
            </a>
          </Button>
        </section>
      </main>
    </ViewWrapper>
  );
};
